<div class="container-fluid">

  <mat-card class="col-md-4 col-md-offset-4 form-signin">

    <form [formGroup]="loginForm" (submit)="login()">
      <mat-card-title>Einloggen</mat-card-title>

      <div *ngIf="errorMessage != ''" class="alert alert-danger">
        <strong>Error occurred!</strong>
        {{errorMessage}}
      </div>

      <label for="inputEmail" class="sr-only">Email address</label>
      <mat-form-field>
        <input matInput type="email" class="full-width" formControlName="email" id="inputEmail" placeholder="Email address"
               autofocus />
      </mat-form-field>

      <label for="inputPassword" class="sr-only">Password</label>

      <mat-form-field>
        <input matInput type="password" class="full-width" id="inputPassword" formControlName="password" placeholder="Password"
               required />
      </mat-form-field>
      <mat-checkbox  formControlName="remember">Eingeloggt bleiben</mat-checkbox>

      <footer class="row">
        <div class="col-sm-4">
          <button mat-raised-button type="submit" class="btn-block" color="primary">Einloggen</button>
        </div>
        <div class="col-sm-4">
          <mat-progress-spinner *ngIf="isLoading" mode="indeterminate"></mat-progress-spinner>
        </div>
      </footer>
      <footer class="signup">
        <a routerLink="/register">Noch keinen Account?</a>
      </footer>
    </form>
  </mat-card>


</div> <!-- /container -->



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/login/login.component.html